import { render, staticRenderFns } from "./VueLoadingOverlayCustom.vue?vue&type=template&id=50a4b274&scoped=true"
import script from "./VueLoadingOverlayCustom.vue?vue&type=script&lang=js"
export * from "./VueLoadingOverlayCustom.vue?vue&type=script&lang=js"
import style0 from "./VueLoadingOverlayCustom.vue?vue&type=style&index=0&id=50a4b274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4b274",
  null
  
)

export default component.exports